<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/local"> Cadastro/Locais </router-link>
      <label class="labelBar"> / </label>
      <label> Editar</label>
    </div>

    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center" >
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="unidAdmAtivo" label="Unidade Administrativa"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="localEntregaAtivo" label="Local De Entrega"></v-checkbox> 
          </v-col>
      </v-row>

      <v-row align="center">
          <v-col cols="12" sm="8">
            <v-text-field
              label="Local *"
              v-model="descricao"
              :counter="200"
              :rules="[(v) => !!v || 'A descrição do local é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Obra nº *"
              v-model="numeroDoLocal"
              :counter="15"
              :rules="[(v) => !!v || 'O Número Do Local é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="12">
            <v-text-field
              label="Contratante"
              v-model="contratante"
              :counter="200"
              required
            ></v-text-field>
          </v-col>
        </v-row>        
        <endereco ref="endereco" :isAllowed="readOnly" />
      </v-form>
      <v-row align="center">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="local.ativo"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn to="/local" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="editar" color="success" class="mr-4"> Atualizar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarLocalAsync } from "../../../services/localService";
import Endereco from "../Endereco";
import { mapState, mapActions } from "vuex";
//import Local from "./Local";

export default {
  name: "editarlocal",
  data: () => ({
    overlay: false,
    valid: true,
    localEntregaAtivo: false,
    unidAdmAtivo: false,
    descricao: null,
    numeroDoLocal: null,
    contratante: null,
    idTipoLocais: null,
    readOnly: false,
    ativo: false,
  }),
  computed: {
    ...mapState("local", ["local"]),
  },
  methods: {
    ...mapActions("local", ["updateLocal"]),
    async editar()
    {
      var enderecoValido = this.$refs.endereco.updateObjectEstate();
      this.idTipoLocais = this.validaTipoLocais();

      if ((this.unidAdmAtivo === false) && ((this.localEntregaAtivo === false)))
      {
        this.$alert("Checkbox não preenchido", "Gentileza preencher o checkbox", "error");
        this.overlay = false;
      }
      else
      { 
        if (this.$refs.form.validate() && enderecoValido) 
        {
          this.overlay = true;
          const resposta = await editarLocalAsync(
            this.local.id,
            this.descricao,
            this.idTipoLocais,
            this.contratante,
            this.numeroDoLocal,
            this.$refs.endereco.cep,
            this.$refs.endereco.logradouro,
            this.$refs.endereco.numero,
            this.$refs.endereco.complemento,
            this.$refs.endereco.bairro,
            this.$refs.endereco.cidade,
            this.$refs.endereco.uf,
            this.local.ativo
          );

          if (!resposta || resposta.message) 
          {
           this.overlay = false;
           this.$alert(resposta && resposta.message ? resposta.message : "", "Desculpe, falha na operação!", "error");
          }
          else
          {
            this.overlay = false;
          this.updateLocal(this.mountObjLocal(resposta));
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
            this.$router.push("/local");
          }
        }
      }
    },
    mountObjLocal(localSalvo) {
      return {
        ...localSalvo,
        tipoLocal: this.getTipoLocal(this.idTipoLocais),
        enderecoCompleto: this.getEnderecoCompleto(),
      };
    },
    getTipoLocal(idTipoLocais) {
      if (idTipoLocais === 3) return "Unidade Administrativa/Local De Entrega";
      if (idTipoLocais === 2) return "Unidade Administrativa";
      if (idTipoLocais === 1) return "Local De Entrega";
      return "";
    },
    getEnderecoCompleto() {
      return [
        this.$refs.endereco.logradouro,
        this.$refs.endereco.numero,
        this.$refs.endereco.bairro,
        this.$refs.endereco.cidade,
        this.$refs.endereco.uf,
      ].filter(Boolean).join(", ");
    },
    validaTipoLocais() 
    {
      if ((this.unidAdmAtivo === true) &&((this.localEntregaAtivo === true)))
      {
        return 3;
      }
      else if ((this.unidAdmAtivo === true) &&((this.localEntregaAtivo === false)))
      {
        return 2;
      }
      else if ((this.unidAdmAtivo === false) &&((this.localEntregaAtivo === true)))
      {
        return 1;
      }
    }
  },
  created: function () {
    //this.readOnly = !getUserPermission(6);
    this.descricao = this.local.descricao;
    this.numeroDoLocal = this.local.numeroDoLocal;
    this.contratante = this.local.contratante;
    this.unidAdmAtivo = this.local.unidAdmAtivo;
    this.localEntregaAtivo = this.local.localEntregaAtivo;
    this.ativo = this.local.ativo;

    if (this.local.idTipoLocais === 3)
    {
      this.unidAdmAtivo = true;
      this.localEntregaAtivo = true;
    }
    else if (this.local.idTipoLocais === 2)
    {
      this.unidAdmAtivo = true;
      this.localEntregaAtivo = false;
    }
    else if (this.local.idTipoLocais === 1)
    {
      this.unidAdmAtivo = false;
      this.localEntregaAtivo = true;
    }
  },
  mounted() {
    //this.readOnly = !getUserPermission(5);
    var endereco = new Object();
    endereco.cep = this.local.cep;
    endereco.logradouro = this.local.logradouro;
    endereco.numero = this.local.numero;
    endereco.complemento = this.local.complemento;
    endereco.bairro = this.local.bairro;
    endereco.cidade = this.local.cidade;
    endereco.uf = this.local.uf;
    this.$refs.endereco.updateObject2(endereco);
  },
  components: {
    Endereco,
  },
};
</script>
